module.exports = __webpack_public_path__ + "img/2.f5941c02.png";